// extracted by mini-css-extract-plugin
module.exports = {"container":"share-survey_container_Y6hgC","common":"share-survey_common_2GYek","title":"share-survey_title_2C8QJ","chartBox":"share-survey_chartBox_YaBM7"};